/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PalmIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="palm-icon">
      <path d="M18.41,23.5 C18.41,20 13.181,19 9.455,19 C5.74,19 0.5,20 0.5,23.5 L18.41,23.5 Z" />
      <polyline points="6.078 19.276 12 8.5 11.518 19.101" />
      <path d="M12,8.5 C8.5,11 5,11 0.955,10.784 C3,6 9.5,6.5 12,7.5 L12,8.5 Z" />
      <path d="M4.5,4.5 C8.102,2.1 12,5 12,7.5 L4.5,4.5 Z" />
      <path d="M12,8.5 C14.5,11.5 19,11 23.045,10.784 C21,6 14.5,6.5 12,7.5 L12,8.5 Z" />
      <path d="M19.5,4.5 C15.898,2.1 12,5 12,7.5 L19.5,4.5 Z" />
      <path d="M10,17 L11.596,17" />
      <path d="M10.5,15 L11.69,15" />
    </g>
  </svg>
);

export default PalmIcon;
